export default {
      user: state => {
        return state.user
      },
      auth: state => {
        return state.auth
      },
      status: state => {
        return state.status
      },
      menu: state => {
        return state.menu
      },
      getCarrinho: state => {
        return state.carrinho
      },
      isQuadro: state => {
          console.log(state.user);

          return state.user
              &&_.toNumber(state.user.dados_perfil.fk_id_tipo_de_usuario) == 3
              && _.toNumber(state.user.pk_id_quadro) > 0
              && _.indexOf([15,16,47], _.toNumber(localStorage.getItem('grupoUsuario'))) > -1
      },
      isFiliadoMilitante: state => {
          return state.user
              && _.toNumber(state.user.dados_perfil.fk_id_tipo_de_usuario) == 2
              && _.indexOf([15], localStorage.getItem('grupoUsuario')) > -1
      },
      isPessoaFisica: state => {
          return state.user
              && _.toNumber(state.user.dados_perfil.fk_id_tipo_de_usuario) == 4
      },

}



// WEBPACK FOOTER //
// ./src/vuex/getters.js